module.exports = __webpack_public_path__ + "static/img/downimg.83f626b.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/honggu/downimg.png
// module id = 5OaK
// module chunks = 88